<template>
  <vs-popup class="raw_material_manage_popup"
            id="popup__"
            title="ADD RAW MATERIALS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickRawMaterialAddConfirm)" autocomplete="off">

          <div class="flex flex-wrap items-center justify-end mb-4">
          <vs-button button="submit" class="ml-auto mt-2">Save formulation</vs-button>
          </div>

          <vx-card cardBorder noShadow title="Raw Materials & Formulations">
            <div class="vx-row my-8">
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <vs-input v-on:keydown.enter.prevent="onTypeSearch" v-model="search" icon-pack="feather" icon="icon-search"
                          placeholder="Search"
                          class="w-full"/>
                          <small class="text-danger">*Please enter minimum 3 characters to search.</small>
              </div>
              <div class="vx-col md:w-1/5 w-full md:mb-0">
                <vs-button :disabled="search.length < 3 && search.length !== 0" v-on:click="onTypeSearch" class="" type="border">search</vs-button>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
              </div>
            </div>
            <vs-table v-on:selected="checkSelected($event)" id="popup" multiple :onlyClickCheckbox="true" v-if="selectedRawMaterials.length > 0 || search.length > 0"
                      v-model="selectedRawMaterials"
                      :data="raw_materials">

              <template slot="thead">
                <vs-th>ITS PROD CODE</vs-th>
                <vs-th>COMPANY PROD NAME</vs-th>
                <vs-th>STAGE</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th width="15%">QUANTITY (KG)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].company_product_code">
                    {{ data[indextr].type === 'Raw Material' ? data[indextr].category.prefix+ '-'
                    +data[indextr].company_product_code : data[indextr].formulation_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].type === 'Raw Material' ? data[indextr].company_product_name : data[indextr].name}}
                  </vs-td>
                  <vs-td :data="data[indextr].raw_material_stage">
                    {{ data[indextr].type === 'Raw Material' ? data[indextr].raw_material_stage : 'N/A'}}
                  </vs-td>
                  <vs-td :data="data[indextr].status.name">
                    {{ data[indextr].status.name || 'N/A' }}
                  </vs-td>
                  <vs-td>
                    <ValidationProvider :vid="indextr+'quantity'" :name="indextr+'quantity'" :rules="quantityRules(data[indextr])" v-slot="{ errors }">
                      <vs-input v-on:input="onChangeInput(data[indextr])" step="0.0001" type="number" v-model="data[indextr].quantity" class="w-full"
                                :name="indextr+'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                    </ValidationProvider>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>

          <vx-card cardBorder noShadow class="mt-4" title="Raw Materials from 3rd party" v-if="formulation_type === 'spray dry powder'">
            <vs-table v-on:selected="checkSelected($event)" id="popup" multiple :onlyClickCheckbox="true"  
            v-model="selectedSprayDryCarriers"
            :data="spray_dry_carriers_list">

            <template slot="thead">
              <vs-th>PRODUCT CODE</vs-th>
              <vs-th>PRODUCT NAME</vs-th>
              <vs-th width="15%">QUANTITY (KG)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].code">
                  {{ data[indextr].code }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <div :class="data[indextr].is_liquid ? 'vx-col w-1/2' : 'vx-col w-full'">
                      <ValidationProvider :vid="indextr+'carrier_quantity'" :name="indextr+'carrier_quantity'" :rules="quantityRulesCarriers(data[indextr])" v-slot="{ errors }">
                        <small v-if="data[indextr].is_liquid">Input</small>
                        <vs-input v-on:input="onChangeSprayDryCarrierInput(data[indextr])" step="0.0001" type="number" v-model="data[indextr].quantity" class="w-full"
                                  :name="indextr+'carrier_quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                  val-icon-pack="feather"/>
                      </ValidationProvider> 
                    </div>
                    <div :class="data[indextr].is_liquid ? 'vx-col w-1/2' : 'vx-col w-full'"  v-if="data[indextr].is_liquid">
                      <ValidationProvider :vid="indextr+'carrier_quantity_finish'" :name="indextr+'carrier_quantity_finish'" :rules="quantityRulesCarriers(data[indextr])" v-slot="{ errors }">
                        <small>Output</small>
                        <vs-input step="0.0001" type="number" v-model="data[indextr].finished_quantity" class="w-full"
                                  :name="indextr+'carrier_quantity_finish'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                  val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                </vs-td>

              </vs-tr>
            </template>
            </vs-table>
          </vx-card>
       
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Filter from '@/mixins/filter';

  const FormulationsRepository = RepositoryFactory.get('formulations');
  const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

  function initialState() {
    return {
      open: false,
      formulationId: '',
      raw_materials: [],
      selectedRawMaterials: [],
      filters: {},
      search: '',
      suspendedRawMaterials: [],
      isFullyDilCodedFormulation: false,
      isProductionFormulation: false,
      linked_formulations_to_dilution: [],
      spray_dry_carriers_list: [],
      selectedSprayDryCarriers: [],
    }
  }

  export default {
    name: 'RawMaterialAddToFormulationPopUp',
    props: {
      raw_material_items: {
        type: Array
      },
      formulation_type: {
        type: String
      },
      spray_dry_carriers: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id, isFullyDilCodedFormulation, isProductionFormulation, linked_formulations_to_dilution = []) {
        try {
          await Object.assign(this.$data, initialState());
          this.formulationId = id
          this.isFullyDilCodedFormulation = isFullyDilCodedFormulation
          this.isProductionFormulation = isProductionFormulation
          this.linked_formulations_to_dilution = linked_formulations_to_dilution
          this.open = true;
          await this.fetchRawMaterial();
          if(this.formulation_type === 'spray dry powder') {
            await this.fetchSprayDryCarriers();
          }
        } catch (error) {

        }
      },
      async onClickRawMaterialAddConfirm() {
        if(this.isFullyDilCodedFormulation && this.linked_formulations_to_dilution.length > 0) {
          const formulation_names = this.linked_formulations_to_dilution.map(f => `${f.name || ''} (${f.code || ''})`).join(', ');
          this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: 'Warning',
              text: `( ${formulation_names} ) use this DIL code and will be suspended until QC reinstated. Are you sure you wish to make this change?`,
              acceptText: 'Confirm',
              accept: this.onClickRawMaterialAdd,
              cancel: () => { this.$parent.refreshAll() ; this.open = false; }
          })
        } else if(this.isProductionFormulation) {
          this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: 'Warning',
              text: 'You are about to save an edit to a live formulation. This will suspend this formulation until QC has been approved for use. Confirm you wish to proceed?',
              acceptText: 'Confirm',
              accept: this.onClickRawMaterialAdd,
              cancel: () => { this.$parent.refreshAll() ; this.open = false; }
          })
        } else {
          await this.onClickRawMaterialAdd()
        }
      },
      async onClickRawMaterialAdd() {
        const vue = this;
        await this.$vs.loading({
          container: '#popup',
          scale: 0.50
        });

        if (this.raw_material_list_with_suspended.length > 0) {
          this.selectedRawMaterials.push(...this.raw_material_list_with_suspended)
        }

        let raw_material_for_formula = this.selectedRawMaterials.reduce(function (filtered, option) {
          if (option.type === 'Raw Material') {
            let obj = {id: option.id, quantity: option.quantity || 0, manufacture_order: '0'};
            filtered.push(obj);
          }
          return filtered;
        }, []);

        let finished_formula_array = this.selectedRawMaterials.reduce(function (filtered, option) {
          if (option.type === 'Formulation' && option.formulation_code && !/^DIL-|^EXT-|^KEY-/.test(option.formulation_code)) {
            let obj = {id: option.id, quantity: option.quantity || 0};
            filtered.push(obj);
          }
          return filtered;
        }, []);
        let dil_coded_formula = this.selectedRawMaterials.reduce(function (filtered, option) {
          if (option.type === 'Formulation' && option.formulation_code && /^DIL-|^EXT-|^KEY-/.test(option.formulation_code)) {
            let obj = {id: option.id, quantity: option.quantity || 0};
            filtered.push(obj);
          }
          return filtered;
        }, []);

        const carrier_items = this.selectedSprayDryCarriers.map((x) => {
          let ob = {id: x.id, quantity: Number(x.quantity).toFixed(2), manufacture_order: '0'}
          if(x.is_liquid) {
            ob.finished_quantity =  Number(x.finished_quantity).toFixed(4)
          }
          return ob
        })

        if (finished_formula_array.length === 0) {
          try {
            await FormulationsRepository.updateFormulationsItems(this.formulationId, {raw_material_items: raw_material_for_formula, formulation_items: dil_coded_formula, carrier_items: carrier_items});
            this.showSuccessMessage('Formulation Updated successfully!');
            await vue.$parent.refreshAll();
            await this.$vs.loading.close('#popup > .con-vs-loading');
            this.open = false;
          } catch (e) {
            await this.$vs.loading.close('#popup > .con-vs-loading')
            this.convertAndNotifyError(e)
          }
        } else {
          try {
            let {data} = (await FormulationsRepository.formulaCalculate({
              raw_materials: raw_material_for_formula,
              formulations: [...dil_coded_formula, ...finished_formula_array]
            })).data;
            const payload = data.map((n) => {
              n.manufacture_order = '0'
              return n
            })
            const calculated_rm_array = payload.filter((x) => x.type === 'rm').map((x) => ({id: x.id, quantity: x.quantity}))
            const calculated_fg_array = payload.filter((x) => x.type === 'fg').map((x) => ({id: x.id, quantity: x.quantity}))
            await FormulationsRepository.updateFormulationsItems(this.formulationId, {raw_material_items: calculated_rm_array, formulation_items: calculated_fg_array, carrier_items: carrier_items});
            this.showSuccessMessage('Formulation Updated successfully!');
            await vue.$parent.refreshAll();
            await this.$vs.loading.close('#popup > .con-vs-loading');
            this.open = false;
          } catch (e) {
            await this.$vs.loading.close('#popup > .con-vs-loading')
            this.convertAndNotifyError(e)
          }
        }
        this.$vs.loading.close()
      },

      async fetchRawMaterial() {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.50
        });
        try {
          let selected_fg_ids = []
          let selected_rm_ids = []
          if(this.search.length === 0) {
            selected_fg_ids = this.raw_material_list_without_suspended.filter((x) => x.formulation_code).map((y) => y.id)
            selected_rm_ids = this.raw_material_list_without_suspended.filter((x) => !x.formulation_code).map((y) => y.id)
          }
          if(this.search.length === 0 && selected_fg_ids.length === 0 && selected_rm_ids.length === 0) {
            this.raw_materials = [];
            return 
          }
          this.raw_materials = [];
          const {data} = await FormulationsRepository.getFormulationsRawMaterial(
            this.search, this.formulationId, selected_fg_ids.toString(), selected_rm_ids.toString()
          );
          if (data.data.length > 0) {
            this.raw_materials = data.data ? data.data.map((m) => {
              let existing = this.selectedRawMaterials.find((s) => s.id === m.id && s.type === m.type) ||
                this.raw_material_list_without_suspended.find((f) => {
                  return (f.id === m.id && m.type === 'Raw Material' && !!f.company_product_code) ||
                    (f.id === m.id && m.type === 'Formulation' && /^DIL-|^EXT-|^KEY-/.test(m.formulation_code) && !!f.formulation_code)
                });
              let object = m;
              object.quantity = existing ? existing.quantity : null;
              return object;
            }) : [];

            this.raw_materials.forEach((rm) => {
              const index = this.selectedRawMaterials.findIndex((s) => s.id === rm.id && s.type === rm.type);
              if (rm.quantity) {
                if (index !== -1) {
                  this.selectedRawMaterials.splice(index, 1, rm);
                } else {
                  this.selectedRawMaterials.push(rm);
                }
              }
            });

            if(this.search.length === 0) {
              this.raw_materials = this.raw_materials.filter((x) => x.quantity)
            }
          } else {
            this.raw_materials = []
          }
        } catch (e) {
          await this.$vs.loading.close('#popup > .con-vs-loading')
        }
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async fetchSprayDryCarriers() {
        try {
          const { data } = (await SprayDryCostRepository.getSprayDryCarriersList()).data
          this.spray_dry_carriers_list = data ? data.map((m) => {
            let object = m;
            object.quantity = null;
            return object
          }) : []

          this.selectedSprayDryCarriers = this.spray_dry_carriers.map((f) => {
            let object = this.spray_dry_carriers_list.find((n) => f.id === n.id);
            object.quantity = f.quantity ? f.quantity : null;
            if(f.is_liquid) {
              object.finished_quantity = f.finished_quantity ? f.finished_quantity : null;
            }
            return object
          })
        } catch (error) {
          
        }
      },
      async loadFormulationsAndGetRmIdArray(id, quantity) {
        const {data} = await FormulationsRepository.details(id);
        let raw_material_items = data.data.raw_material_items;
        let raw_material_items_array = [];
        raw_material_items.forEach((m) => {
          raw_material_items_array.push({id: m.id, quantity: quantity})
        });
        return raw_material_items_array
      },
      onChangeInput(data) {
        const find = this.selectedRawMaterials.find((x) => {
          return x.id === data.id && x.type === data.type
        })
        if(Number(data.quantity) > 0 && !find) {
          this.selectedRawMaterials.push(data)
        } else if(Number(data.quantity) === 0 || !data.quantity) {
          this.selectedRawMaterials = this.selectedRawMaterials.filter((x) => {
            return !(x.id === data.id && x.type === data.type)
          })
        }
        // TODO: ON CHANGE QTY FUNCTION
        // const find = this.selectedRawMaterials.find((x) => x.id === data.id && x.type === data.type)
        // if (Number(data.quantity) > 0) {
        //   this.selectedRawMaterials.push(data)
        // } else {
        //   this.selectedRawMaterials = this.selectedRawMaterials.filter(function( obj ) {
        //     return !(obj.id === data.id && obj.type === data.type);
        //   });
        // }
      },
      onChangeSprayDryCarrierInput(data) {
        const find = this.selectedSprayDryCarriers.find((x) => {
          return x.id === data.id
        })
        if(Number(data.quantity) > 0 && !find) {
          this.selectedSprayDryCarriers.push(data)
        } else if(Number(data.quantity) === 0 || !data.quantity) {
          this.selectedSprayDryCarriers = this.selectedSprayDryCarriers.filter((x) => {
            return x.id !== data.id
          })
        }
      },
      checkSelected(data) {
        // if(data.type === 'Raw Material' && (data.status.name !== 'Approved' || data.raw_material_stage !== 'production')) {
        //   this.selectedRawMaterials = this.selectedRawMaterials.filter((n) => {
        //     return !(n.type === 'Raw Material' && n.id === data.id)
        //   })
        // }
      },
      onClickReset() {
        this.createStaffForm = {};
        this.selected = []
      },
      async onTypeSearch() {
        if(this.search.length > 2 || this.search.length === 0){
          await this.fetchRawMaterial()
        }
      },
      filterQueryUpdate() {
        // this.fetchRawMaterial()
        // this.fetchRawMaterial()
      },
      suitableOrCertified(suitable, certified) {
        let text = '';
        if (suitable === 'Yes') {
          text = text + ' S'
        }
        if (certified === 'Yes') {
          text = text + ' C'
        }
        return text
      },
      quantityRules(data) {
        if (!data.quantity && this.selectedRawMaterials.includes(data)) {
          return 'required'
        } else {
          return ''
        }
      },
      quantityRulesCarriers(data) {
        if (!data.quantity && this.selectedSprayDryCarriers.includes(data)) {
          return 'required'
        } else {
          return ''
        }
      }
    },
    async mounted() {

    },
    computed: {
      raw_material_list_without_suspended() {
        return this.raw_material_items.filter((m) => {
          // if(m.status) {
          //   return !m.status.name.includes('Suspended')
          // } else {
            return m
          // }

        })
      },
      raw_material_list_with_suspended() {
        return this.raw_material_items.filter((m) => {
          // if(m.status) {
          //   return m.status.name.includes('Suspended')
          // } else {
            return m
          // }
        })
      },
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
  }
</script>

<style scoped>
  .raw_material_manage_popup >>> .vs-popup {
    min-height: 30% !important;
    min-width: 80% !important;
  }


</style>
